import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8493e0c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hound-card__img" }, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hound-card__img__armor" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hound-card__img__neon" }, null, -1))
const _hoisted_4 = {
  key: 0,
  class: "hound-card__disabled"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_ellipsis = _resolveComponent("n-ellipsis")!
  const _component_n_text = _resolveComponent("n-text")!
  const _component_n_h4 = _resolveComponent("n-h4")!
  const _component_n_space = _resolveComponent("n-space")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["hound-card avatar", `
      avatar-component-${_ctx.hound.extensionTraits ? _ctx.hound.extensionTraits : _ctx.hound.head[3]}-${_ctx.hound.color[3]}
      avatar-neon-${_ctx.hound.extensionTraits ? _ctx.hound.extensionTraits : _ctx.hound.head[3]}-${_ctx.hound.color[2]}
    `])
  }, [
    _createElementVNode("div", null, [
      _hoisted_1,
      _hoisted_2,
      _hoisted_3,
      _createElementVNode("div", {
        style: _normalizeStyle(`margin-left: ${_ctx.infoMarginLeft}`)
      }, [
        _createVNode(_component_n_space, {
          vertical: "",
          justify: "center"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_n_h4, { style: {"margin-bottom":"0"} }, {
              default: _withCtx(() => [
                _createVNode(_component_n_text, { type: "primary" }, {
                  default: _withCtx(() => [
                    (_ctx.breakpoints.sDown.matches)
                      ? (_openBlock(), _createBlock(_component_n_ellipsis, {
                          key: 0,
                          style: _normalizeStyle({ 'max-width': _ctx.ellipsisSmMax })
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.hound.name), 1)
                          ]),
                          _: 1
                        }, 8, ["style"]))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(_toDisplayString(_ctx.hound.name), 1)
                        ], 64))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (_ctx.showSex)
              ? (_openBlock(), _createBlock(_component_n_h4, {
                  key: 0,
                  style: {"margin-bottom":"0"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_n_text, { type: "info" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.hound.sex), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ], 4)
    ]),
    (_ctx.disabled)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4))
      : _createCommentVNode("", true)
  ], 2))
}